import { i18n } from '@/plugins/i18n'
import DescriptionColumn from '../components/core-common-access-description-column.vue'
import CountryColumn from './../components/country-column'
import { statusVariant, statusStr } from '@/constants/transactionStatus'

const descriptionTemplate = (row, index, datatable) => {
    let template = new DescriptionColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

const countryTemplate = (row, index, datatable) => {
    let template = new CountryColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

export default [
    {
        field: 'country',
        title: i18n.t('label.country_flag'),
        width: 45,
        template: (row, index, datatable) => {
            return countryTemplate(row, index, datatable)
        },
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'id',
        width: 120,
        title: i18n.t('label.reference_id'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'price',
        width: 80,
        title: i18n.t('label.price') + " (" + i18n.t('currency.rial') + ")",
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'transaction_type',
        width: 80,
        title: i18n.t('label.transaction_type'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'port_code',
        title: i18n.t('label.psp'),
        sortable: false,
        textAlign: 'center',
        template: (row) => {
            switch(row.port_code) {
                case 'MELLAT':
                    return '<div><img src="/assets/media/psp/mellat.png" width="32" height="32"></div>';
                case 'PARSIAN':
                    return '<div><img src="/assets/media/psp/parsian.svg" width="32" height="32"></div>';
                case 'PASARGAD':
                    return '<div><img src="/assets/media/psp/pasargad.svg" width="32" height="32"></div>';
                case 'SAMAN':
                    return '<div><img src="/assets/media/psp/saman.svg" width="32" height="32"></div>';
                case 'NOVIN':
                    return '<div><img src="/assets/media/psp/novin.svg" width="32" height="32"></div>';
                case 'ASANPARDAKHT':
                    return '<div><img src="/assets/media/psp/ap-logo.png" width="32" height="32"></div>';
                case 'SADERAT':
                    return '<div><img src="/assets/media/psp/saderat.png" width="32" height="32"></div>';
            }

            return '<span>' + row.port + '</span>';
        },
    },
    {
        field: 'description',
        width: 80,
        title: i18n.t('label.description'),
        template: (row, index, datatable) => {
            return descriptionTemplate(row, index, datatable)
        },
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.date'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        width: 80,
        template: (row) => {
            let variant   = 'badge-'+statusVariant(row.status)
            let status = statusStr.get(row.status)

            return '<div class="badge '+variant+' text-white text-wrap">'+ status +'</div>'
        },
        sortable: true,
        textAlign: 'center',
    },

]
